(() => {
  const init = (root) => {
    if (!root || root.dataset.csReady === 'true') return;
    root.dataset.csReady = 'true';

    const revealTargets = root.querySelectorAll(
      '.cs-hero__copy, .cs-hero__visual, .cs-benefits__grid > div, .cs-form-section > *'
    );
    revealTargets.forEach((element) => element.setAttribute('data-reveal', ''));

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealTargets.forEach((element) => observer.observe(element));
    } else {
      revealTargets.forEach((element) => element.classList.add('is-visible'));
    }

    if (root.querySelector('[data-tally-src]') && !document.querySelector('script[data-cs-tally]')) {
      const tallyScript = document.createElement('script');
      tallyScript.src = 'https://tally.so/widgets/embed.js';
      tallyScript.defer = true;
      tallyScript.dataset.csTally = 'true';
      document.head.appendChild(tallyScript);
    }
  };

  document.querySelectorAll('[data-cs-waitlist]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-cs-waitlist]')));
})();
